<template>
  <q-layout v-if="!hidePage">
    <q-page-container>
      <q-header class="bg-dark q-pa-md">
        <q-toolbar class="q-py-md">
          <AppLogo />
          <q-space />
          <AppAccountDropdown />
        </q-toolbar>
      </q-header>
      <q-page class="flex justify-center items-center q-pa-sm bg-dark">
        <div>
          <transition
            v-if="projects.length"
            enter-active-class="animated animate__fadeInDown"
            leave-active-class="animated animate__fadeOutDown"
            mode="out-in"
            :duration="140"
          >
            <div class="column q-pa-md">
              <div class="row q-mb-xl">
                <div class="bg-primary q-mr-md" style="width: 4px"></div>
                <div class="text-white">
                  <div class="text-h5">Projekt</div>
                  <div class="text-grey-6">Välj projekt för att fortsätta</div>
                </div>
              </div>
              <div class="row">
                <q-card
                  square
                  v-for="project in orderBy(
                    projects,
                    [(p) => hasMasterProject(p.name), 'name'],
                    ['asc', 'asc']
                  )"
                  :key="project.uuid"
                  style="width: 300px"
                  class="shadow-14 q-mb-sm q-mr-sm overflow-hidden"
                  :class="[
                    hasMasterProject(project.name)
                      ? 'bg-grey-9 text-white'
                      : 'bg-white',
                  ]"
                >
                  <div class="row no-wrap" style="height: 100%">
                    <template v-if="projectHasOnlyV2(project.name, false)">
                      <div
                        class="
                          col
                          cursor-pointer
                          bg-primary
                          text-white
                          flex
                          items-center
                          relative-position
                        "
                        v-ripple
                        @click="handleGoToAvikV2(false)"
                      >
                        <q-card-section
                          class="
                            text-caption text-bold text-subtitle1 text-uppercase
                            w-full
                            row
                            items-center
                            justify-between
                          "
                          style="width: 100%"
                        >
                          <div>
                            <q-icon
                              class="q-mr-sm"
                              v-if="hasMasterProject(project.name)"
                              name="mdi-account-supervisor"
                            />
                            {{ project.description }}
                          </div>
                          <div>V2</div>
                        </q-card-section>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="
                          col
                          cursor-pointer
                          flex
                          items-center
                          relative-position
                        "
                        v-ripple
                        @click="openProject(project.name, false)"
                      >
                        <q-card-section
                          class="
                            text-caption text-bold text-subtitle1 text-uppercase
                            q-pr-md
                          "
                        >
                          <q-icon
                            class="q-mr-sm"
                            v-if="hasMasterProject(project.name)"
                            name="mdi-account-supervisor"
                          />
                          {{ project.description }}
                        </q-card-section>
                      </div>

                      <div
                        v-if="projectHasV2(project.name, false)"
                        class="
                          col-auto
                          cursor-pointer
                          bg-primary
                          text-white
                          flex
                          items-center
                          justify-center
                          text-bold
                          relative-position
                          text-subtitle1
                        "
                        style="
                          width: 75px;
                          margin-left: -15px;
                          clip-path: polygon(15px 0, 100% 0, 100% 100%, 0 100%);
                          padding-left: 8px;
                        "
                        v-ripple
                        @click="handleGoToAvikV2(false)"
                      >
                        V2
                      </div>
                    </template>
                  </div>
                </q-card>
              </div>
            </div>
          </transition>

          <transition
            v-if="!!devProjects?.length"
            enter-active-class="animated animate__fadeInDown"
            leave-active-class="animated animate__fadeOutDown"
            mode="out-in"
            :duration="140"
          >
            <div class="column q-pa-md">
              <q-separator
                v-if="projects.length > 0"
                dark
                class="q-mt-lg q-mb-xl"
                style="opacity: 0.3"
              />
              <div class="row q-mb-xl items-center">
                <div
                  class="q-mr-md"
                  style="
                    width: 4px;
                    height: 48px;
                    background-color: oklch(63.7% 0.237 25.331);
                  "
                ></div>
                <div class="text-white">
                  <div
                    class="text-h5 flex items-center"
                    style="color: oklch(63.7% 0.237 25.331)"
                  >
                    <q-icon name="mdi-flask" class="q-mr-sm" />
                    Testmiljöer
                  </div>
                  <div class="text-grey-5">Utvecklings- och testmiljöer</div>
                </div>
              </div>
              <div class="row">
                <q-card
                  square
                  v-for="project in orderBy(
                    devProjects,
                    [(p) => hasMasterProject(p.name), 'name'],
                    ['asc', 'asc']
                  )"
                  :key="project.uuid"
                  style="width: 300px"
                  class="shadow-14 q-mb-sm q-mr-sm overflow-hidden"
                  :class="[
                    hasMasterProject(project.name)
                      ? 'bg-grey-9 text-white'
                      : 'bg-grey-2',
                  ]"
                >
                  <div class="row no-wrap" style="height: 100%">
                    <template v-if="projectHasOnlyV2(project.name, true)">
                      <div
                        class="
                          col
                          cursor-pointer
                          bg-primary
                          text-white
                          flex
                          items-center
                          relative-position
                        "
                        v-ripple
                        @click="handleGoToAvikV2(true)"
                      >
                        <q-card-section
                          class="
                            text-caption text-bold text-subtitle1 text-uppercase
                            w-full
                            row
                            items-center
                            justify-between
                          "
                          style="width: 100%"
                        >
                          <div>
                            <q-icon
                              class="q-mr-sm"
                              v-if="hasMasterProject(project.name)"
                              name="mdi-account-supervisor"
                            />
                            {{ project.description }}
                          </div>
                          <div>V2</div>
                        </q-card-section>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="
                          col
                          cursor-pointer
                          flex
                          items-center
                          relative-position
                        "
                        v-ripple
                        @click="openProject(project.name, true)"
                      >
                        <q-card-section
                          class="
                            text-caption text-bold text-subtitle1 text-uppercase
                            q-pr-md
                          "
                        >
                          <q-icon
                            class="q-mr-sm"
                            v-if="hasMasterProject(project.name)"
                            name="mdi-account-supervisor"
                          />
                          {{ project.description }}
                        </q-card-section>
                      </div>

                      <div
                        v-if="projectHasV2(project.name, true)"
                        class="
                          col-auto
                          cursor-pointer
                          bg-primary
                          text-white
                          flex
                          items-center
                          justify-center
                          text-bold
                          relative-position
                          text-subtitle1
                        "
                        style="
                          width: 75px;
                          margin-left: -15px;
                          clip-path: polygon(15px 0, 100% 0, 100% 100%, 0 100%);
                          padding-left: 8px;
                        "
                        v-ripple
                        @click="handleGoToAvikV2(true)"
                      >
                        V2
                      </div>
                    </template>
                  </div>
                </q-card>
              </div>
            </div>
          </transition>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useProfile } from '@/composable/useProfile'
import { routerPush } from '@/router'
import AppLogo from '@/components/AppLogo.vue'
import AppAccountDropdown from '@/components/AppAccountDropdown.vue'
import { onBeforeRouteLeave } from 'vue-router'
import { getDefaultRoute } from '@/router/priorityDefaultRouteFromProject'
import orderBy from 'lodash.orderby'

// Projekt som alltid ska till V2, oavsett behörigheter
const V2_ONLY_PROJECTS = ['pendeltag']

export default defineComponent({
  name: 'Projects',

  components: {
    AppLogo,
    AppAccountDropdown,
  },

  setup() {
    const handleGoToAvikV2 = (isDev: boolean) => {
      localStorage.setItem('isAvikDev', isDev ? 'true' : 'false')
      window.location.href = 'https://avik.sj.se/v2'
    }
    const { projects, profile, devProjects, devProfile } = useProfile()

    const hidePage = ref(true)

    onBeforeRouteLeave((to) => {
      window.location.pathname = to.path
    })

    const totalProjectsCount = computed(
      () => projects.value.length + (devProjects.value?.length || 0)
    )

    // DEBUG LOGGING
    console.group('Avik Routing Debug Info')
    console.log(
      'Prod projects:',
      projects.value.map((p) => p.name)
    )
    console.log('Dev projects:', devProjects.value?.map((p) => p.name) || [])

    const projectsWithV2 = projects.value
      .filter((p) => projectHasV2(p.name, false))
      .map((p) => p.name)
    const devProjectsWithV2 =
      devProjects.value
        ?.filter((p) => projectHasV2(p.name, true))
        .map((p) => p.name) || []

    console.log('Prod projects with V2 access:', projectsWithV2)
    console.log('Dev projects with V2 access:', devProjectsWithV2)

    let decision = 'Show projects page (hidePage = false)'

    if (totalProjectsCount.value === 1) {
      const isDev = projects.value.length === 0
      const theProject = isDev ? devProjects.value[0] : projects.value[0]
      const projectName = theProject.name
      const profileToUse = isDev ? devProfile.value : profile.value
      const perms = profileToUse?.permissions[projectName] || []

      const hasV2Perm =
        V2_ONLY_PROJECTS.includes(projectName) ||
        perms.some((p) => p.startsWith('v2'))

      if (hasV2Perm) {
        decision = `Auto-redirect to V2 (${
          isDev ? 'Dev' : 'Prod'
        }) for project ${projectName}`
        console.log('Decision would be:', decision)
        console.groupEnd()
        handleGoToAvikV2(isDev)
      } else {
        decision = `Auto-redirect to V1 (${
          isDev ? 'Dev' : 'Prod'
        }) for project ${projectName}`
        console.log('Decision would be:', decision)
        console.groupEnd()
        openProject(projectName, isDev)
      }
    } else {
      console.log('Decision would be:', decision)
      console.groupEnd()
      hidePage.value = false
    }

    function projectHasV2(projectName: string, isDev: boolean) {
      const activeProfile = isDev ? devProfile.value : profile.value
      if (!activeProfile) return false
      const perms = activeProfile.permissions[projectName] || []
      return perms.some((p) => p.startsWith('v2'))
    }

    function projectHasOnlyV2(projectName: string, isDev: boolean) {
      if (V2_ONLY_PROJECTS.includes(projectName)) return true
      const activeProfile = isDev ? devProfile.value : profile.value
      if (!activeProfile) return false
      const perms = activeProfile.permissions[projectName] || []
      return perms.length > 0 && perms.every((p) => p.startsWith('v2'))
    }

    function openProject(project: string, isDev: boolean) {
      if (isDev) localStorage.setItem('isAvikDev', 'true')
      if (!isDev) localStorage.setItem('isAvikDev', 'false')
      if (hasMasterProject(project)) {
        routerPush('masterdata', { project })
      } else if (isDev) {
        if (!devProfile.value) {
          throw new Error('Dev Profile permissions not found')
        }
        routerPush(getDefaultRoute(devProfile.value.permissions[project]), {
          project,
        })
      } else {
        if (!profile.value) {
          throw new Error('Profile permissions not found')
        }
        routerPush(getDefaultRoute(profile.value.permissions[project]), {
          project,
        })
      }
    }

    function hasMasterProject(projectName: string) {
      return projectName === 'master'
    }

    return {
      openProject,
      projects,
      hasMasterProject,
      hidePage,
      orderBy,
      handleGoToAvikV2,
      projectHasV2,
      projectHasOnlyV2,
      devProjects,
    }
  },
})
</script>
